var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content", staticStyle: { height: "100%" } },
      [
        _c("div", { staticClass: "app-main-inner-row" }, [
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _vm.showConfig
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.showConfigButton }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("CargoMsg.Cargo_Config")) + " "
                      )
                    ]
                  )
                : _vm._e(),
              !_vm.showConfig
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.addRows } },
                    [_vm._v(" " + _vm._s(_vm.$t("common.btn.new")) + " ")]
                  )
                : _vm._e(),
              !_vm.showConfig
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.saveOrderConfig }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.btn.save")) + " ")]
                  )
                : _vm._e(),
              !_vm.showConfig
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.showConfigButton }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.btn.cancel")) + " ")]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _c(
          "el-form",
          {
            staticStyle: { "margin-top": "10px" },
            attrs: {
              inline: true,
              "label-width": "80px",
              "label-position": "right"
            }
          },
          [
            _c(
              "div",
              { staticClass: "el-form-item-wrapper" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": "95px",
                      label: _vm.$t("CargoMsg.Cargo_ApplicationBranch")
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { disabled: _vm.showConfig, filterable: "" },
                        on: { change: _vm.changeOfficeHandler },
                        model: {
                          value: _vm.configForm.branchId,
                          callback: function($$v) {
                            _vm.$set(_vm.configForm, "branchId", $$v)
                          },
                          expression: "configForm.branchId"
                        }
                      },
                      _vm._l(_vm.currentOfficeList, function(office) {
                        return _c("el-option", {
                          key: office.uuid,
                          attrs: { value: office.officeId, label: office.code }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      inline: false,
                      "label-width": "140px",
                      label: _vm.$t("CargoMsg.Cargo_StartLine")
                    }
                  },
                  [
                    _c("el-input-number", {
                      attrs: {
                        disabled: _vm.showConfig,
                        "controls-position": "right",
                        min: 1,
                        max: 20
                      },
                      model: {
                        value: _vm.configForm.startLine,
                        callback: function($$v) {
                          _vm.$set(_vm.configForm, "startLine", $$v)
                        },
                        expression: "configForm.startLine"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c("cargo-simple-upload", {
                      staticStyle: { margin: "0 5px" },
                      attrs: {
                        action: _vm.URL.sys.updateOrderTemplateSample,
                        params: {
                          branchId: _vm.configForm.branchId,
                          lob: _vm.lob,
                          sampleFileName:
                            "Import" +
                            _vm.sampleNamePart +
                            "JobDataExample.xlsx"
                        },
                        title: _vm.$t(
                          "CargoMsg.Cargo_UploadTemplateDataSample"
                        ),
                        accept: ".xlsx"
                      },
                      on: { success: _vm.refreshSample }
                    }),
                    _vm.sample && _vm.sample.sampleFileName
                      ? _c(
                          "a",
                          {
                            staticStyle: {
                              display: "inline-block",
                              "font-size": "100%",
                              "margin-left": "38px",
                              color: "#0d76c1"
                            },
                            on: {
                              click: function($event) {
                                return _vm.downloadFile(_vm.sample.sampleFileId)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-paperclip",
                              staticStyle: { "font-size": "18px" }
                            }),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "15px",
                                  "text-decoration": "underline"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.sample.sampleFileName +
                                      " (" +
                                      _vm.curSampleOffice.code +
                                      _vm.$t("CargoMsg.Cargo_Sample") +
                                      ")"
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.sample &&
                    _vm.sample.sampleFileName &&
                    _vm.curSampleOffice.officeId === _vm.configForm.branchId
                      ? _c("i", {
                          staticClass: "el-icon-close",
                          staticStyle: {
                            "font-size": "18px",
                            "margin-left": "5px",
                            "font-weight": "600",
                            color: "#7c7f80"
                          },
                          on: { click: _vm.deleteOrderTemplateSample }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "el-form-item-wrapper" },
              [
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "20px", label: " " } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "vertical-align": "top"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CargoMsg.Cargo_TemplateTips")) +
                            " "
                        )
                      ]
                    ),
                    _c("div", { staticStyle: { display: "inline-block" } }, [
                      _c("div", [
                        _c("span", { staticStyle: { color: "#0000FF" } }, [
                          _vm._v("❇" + _vm._s(_vm.$t("CargoMsg.Cargo_Blue")))
                        ]),
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_MusetSelectd")) + " "
                        )
                      ]),
                      _c("div", { staticStyle: { color: "#555555" } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CargoMsg.Cargo_Sample_Tip")) +
                            " "
                        )
                      ])
                    ])
                  ]
                )
              ],
              1
            )
          ]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tab_style" },
      [
        _c(
          "el-table",
          {
            ref: "listTable",
            staticStyle: { width: "80%" },
            attrs: {
              data: _vm.fieldList,
              "header-cell-class-name": _vm.headerStyle,
              border: "",
              "max-height": "550",
              "highlight-current-row": ""
            },
            on: { "row-click": _vm.clickRow }
          },
          [
            _c("el-table-column", {
              attrs: {
                align: "center",
                width: "70",
                label: _vm.$t("CargoMsg.Cargo_SequenceNumber")
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: _vm.$t("CargoMsg.Cargo_ActualFieldName")
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      !scope.row.isEdit
                        ? _c(
                            "span",
                            {
                              style:
                                scope.row.required === 0 ? "color: #0A0AFF" : ""
                            },
                            [_vm._v(" " + _vm._s(scope.row.headerField) + " ")]
                          )
                        : _vm._e(),
                      scope.row.isEdit
                        ? _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                disabled: scope.row.required === 0
                              },
                              on: {
                                change: function($event) {
                                  return _vm.changeHeaderField(scope.row)
                                }
                              },
                              model: {
                                value: scope.row.headerField,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "headerField", $$v)
                                },
                                expression: "scope.row.headerField"
                              }
                            },
                            _vm._l(_vm.selectedFields, function(item) {
                              return _c("el-option", {
                                key: item.headerField,
                                attrs: {
                                  label: item.headerField,
                                  value: item.headerField
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: _vm.$t("CargoMsg.Cargo_TemplateHeaderName")
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      !scope.row.isEdit
                        ? _c("span", [_vm._v(_vm._s(scope.row.headerName))])
                        : _vm._e(),
                      scope.row.isEdit
                        ? _c("el-input", {
                            model: {
                              value: scope.row.headerName,
                              callback: function($$v) {
                                _vm.$set(scope.row, "headerName", $$v)
                              },
                              expression: "scope.row.headerName"
                            }
                          })
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: _vm.$t("CargoMsg.Cargo_TemplateImportValue")
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      !scope.row.isEdit
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.importValue ||
                                    scope.row.defaultValue !== ""
                                    ? scope.row.importValue
                                    : _vm.$t(
                                        "CargoMsg.Cargo_TemplateDefaultValue"
                                      )
                                ) +
                                " "
                            )
                          ])
                        : _vm._e(),
                      scope.row.isEdit
                        ? _c(
                            "el-select",
                            {
                              model: {
                                value: scope.row.importValue,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "importValue", $$v)
                                },
                                expression: "scope.row.importValue"
                              }
                            },
                            _vm._l(scope.row.selecteds, function(item) {
                              return _c("el-option", {
                                key: item,
                                attrs: { label: item, value: item }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _c(
              "el-table-column",
              {
                attrs: {
                  align: "center",
                  label: _vm.$t("CargoMsg.Cargo_OrderDefaultValue")
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        !scope.row.isEdit
                          ? _c("span", [_vm._v(_vm._s(scope.row.defaultValue))])
                          : _vm._e(),
                        scope.row.isEdit
                          ? _c("el-input", {
                              model: {
                                value: scope.row.defaultValue,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "defaultValue", $$v)
                                },
                                expression: "scope.row.defaultValue"
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ])
              },
              [
                _c(
                  "template",
                  { slot: "header" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: _vm.$t("CargoMsg.Cargo_TemplateDefault"),
                          placement: "top-start"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CargoMsg.Cargo_OrderDefaultValue")) +
                            " "
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "padding-left": "8px",
                              "font-size": "20px"
                            }
                          },
                          [_vm._v("?")]
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              2
            ),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: _vm.$t("CargoMsg.CargoFieldDescription")
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      !scope.row.isEdit
                        ? _c("span", [_vm._v(_vm._s(scope.row.description))])
                        : _vm._e(),
                      scope.row.isEdit
                        ? _c("el-input", {
                            staticStyle: { cursor: "pointer" },
                            model: {
                              value: scope.row.description,
                              callback: function($$v) {
                                _vm.$set(scope.row, "description", $$v)
                              },
                              expression: "scope.row.description"
                            }
                          })
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: _vm.$t("CargoMsg.Cargo_FieldDropdownValue")
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      !scope.row.isEdit
                        ? _c("span", [_vm._v(_vm._s(scope.row.options))])
                        : _vm._e(),
                      scope.row.isEdit
                        ? _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: scope.row.options,
                              callback: function($$v) {
                                _vm.$set(scope.row, "options", $$v)
                              },
                              expression: "scope.row.options"
                            }
                          })
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                width: "100",
                label: _vm.$t("CargoMsg.Cargo_OrderOperation")
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      scope.row.required === 1 && !_vm.showConfig
                        ? _c("el-button", {
                            attrs: { size: "mini", icon: "el-icon-delete" },
                            on: {
                              click: function($event) {
                                return _vm.deleteRow(scope.row)
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }